/**
 * HlsDateRange
 *
 *  processes Hls DateRanges
 *
 */
'use strict';

import Utils from '../HlsUtils';

/**
* @access internal
*/
class HlsDateRange {

	constructor(dateRange) {

		this._rawDateRange = dateRange;
		this._parse();
	}


	dispose() {
	}


	set(dateRange) {
		this._rawDateRange = dateRange;

		this._parse();
	}


	get id() {
		return this._id;
	}


	get startDate() {
		return this._startDate;
	}


	get plannedDuration() {
		return this._plannedDuration;
	}


	get duration() {
		return this._duration;
	}


	get bamcmd() {
		return this._bamcmd;
	}


	get rawDateRange() {
		return this._rawDateRange;
	}


	clearValues() {
		this._id = undefined;
		this._startDate = undefined;
		this._bamcmd = undefined;
		this._plannedDuration = undefined;
		this._duration = undefined;
	}


	_parse() {
		if (this._rawDateRange != null && Utils.isString(this._rawDateRange)) {
			this._split = this._rawDateRange.split(',');
			let splitLen = this._split.length;

			//console.log(this._split);

			for (let i = 0; i < splitLen; i++) {
				let innerSplit = this._split[i].split('=');
				if (innerSplit.length > 1) {

					let value = innerSplit[1].replace(/^"(.*)"$/, '$1');

					if (innerSplit[0] === 'ID') {
						this._id = value;
					}
					else if (innerSplit[0] === 'START-DATE') {
						this._startDate = value;
					}
					else if (innerSplit[0] === 'PLANNED-DURATION') {
						this._plannedDuration = value;
					}
					else if (innerSplit[0] === 'DURATION') {
						this._duration = value;
					}
					else if (innerSplit[0] === 'X-BAM-CMD') {
						this._bamcmd = value;
					}
				}
			}
		}
		else {
			this.clearValues();
		}
	}



}
export default HlsDateRange;




// WEBPACK FOOTER //
// ./src/utils/hlsDateRange.js